<template>
  <vs-row vs-justify="center">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="10"
      vs-xs="12"
    >
      <vs-card>
        <vs-collapse>
          <vs-collapse-item open>
            <div slot="header">
              <h3 class="card-title d-flex">
                Business Information
              </h3>
            </div>
            <vs-row>
              <vs-col vs-lg="6" vs-xs="12">
                <vs-input v-model="accName" label="Business Name" />
              </vs-col>
              <vs-col vs-lg="6" vs-xs="12">
                <vs-input
                  v-model="shortDescription"
                  label="Short Description"
                />
              </vs-col>
               <category v-model="category" />
              <City v-model="city"/>
              <vs-col vs-lg="6" vs-xs="12">
                <vs-input v-model="accountInfo.name" label="Contact Person" />
              </vs-col>
              <vs-col vs-lg="6" vs-xs="12">
                <vs-input v-model="accountInfo.phone" label="Contact Number" />
              </vs-col>
              <vs-col vs-lg="6" vs-xs="12">
                <vs-input
                  v-model="accountInfo.landline"
                  label="Landline Number"
                />
              </vs-col>
              <vs-col vs-lg="6" vs-xs="12">
                <vs-input
                  v-model="accountInfo.whatsapp"
                  label="Whatsapp Number"
                />
              </vs-col>
              <vs-col vs-lg="6" vs-xs="12">
                <vs-input v-model="accountInfo.email" label="Contact Email" />
              </vs-col>
             
              <vs-col vs-lg="6" vs-xs="12" class="mt15">
                <label for="">Is Featured Account?</label>
                <vs-switch color="success" v-model="isFeatured">
                  <span slot="on">Accept</span>
                  <span slot="off">Cancel</span>
                </vs-switch>
              </vs-col>
            </vs-row>
          </vs-collapse-item>

          <vs-collapse-item open>
            <div slot="header">
              <h3 class="card-title d-flex">
                Address Info
              </h3>
            </div>
            <gAdd v-model="add" />
            <vs-col vs-lg="12" vs-xs="12" v-if="mapURL && mapURL.indexOf('https://maps.google.com') >= 0">
              <iframe :src="mapURL" class="iframe" />
            </vs-col>
          </vs-collapse-item>

          <vs-collapse-item open>
            <div slot="header">
              <h3 class="card-title d-flex">
                Upload Images
              </h3>
            </div>

            <vs-row>
              <vs-col vs-lg="12" vs-xs="12">
                <uploader multiple label="Upload Images(Select all images in one go)" v-model="images" imgSize="6" /> </vs-col
            ></vs-row>
          </vs-collapse-item>

          <vs-collapse-item open>
            <div slot="header">
              <h3 class="card-title d-flex">
                Social Links
              </h3>
            </div>
            <social v-model="links" />
            <vs-button @click="save">Save</vs-button>
          </vs-collapse-item>
        </vs-collapse>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import gAdd from "../common/google-address.vue";
import social from "../common/social-links.vue";
import category from "../common/category.vue";
import City from "../common/city.vue";

import { API } from "@/common/constants";
import uploader from "../common/uploader.vue";
export default {
  name: "Accounts",
  components: { gAdd, social, uploader, category, City },
  data: () => ({
    isFeatured: false,
    add: null,
    links: {},
    images: [],
    all: [],
    category: null,
    city: null,
    accName: "",
    accountInfo: {
      name: "",
      email: "",
      phone: "",
    },
    shortDescription: "",
  }),
  computed: {
    mapURL() {
      return this.$data.add != null ? this.$data.add.mapUrl : "";
    },
  },
  methods: {
    save() {
      const data = {
        accName: this.$data.accName,
        ...this.$data.category,
        ...this.$data.city,
        isFeatured: this.$data.isFeatured,
        socialLinks: this.$data.links,
        ...this.$data.add,
        images: this.$data.images,
        accountInfo: this.$data.accountInfo,
        meta: "",
        shortDescription: this.$data.shortDescription
      };
      api
        .post(API.ACCOUNT_DETAIL_INSERT, data)
        .then((r) => {
          if(r.data.status) {
            this.resetForm();
             this.$vs.notify({
              text: "Business Added Successfully",
              color: "success",
              position: "top-center",
            });
          } else {
             this.$vs.notify({
              text: r.data.error,
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch();
    },
    resetForm() {
      this.$data.isFeatured = false;
      this.$data.add = null;
      this.$data.links = {};
      this.$data.images = [];
      this.$data.all = [];
      this.$data.category = null;
      this.$data.accName = "";
      this.$events.emit("reset");
    },
  },
};
</script>
<style scoped>
.iframe {
  width: 100%;
  margin-top: 15px;
  height: 195px;
  border: 0px !important;
}
.mt15 {
  margin-top: 15px;
}
</style>
